<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="pa-4">
    <v-col cols="12" xs="12" sm="12" class="pt-0 py-0" v-if="showTitle">
      <span class="headline" v-if="!isChannels">Playlists</span>
      <span class="headline" v-else>Channels</span>
    </v-col>
    <v-col cols="12" xs="12" sm="4" class="py-0" v-if="!isCompanyView && !isChannels">
      <v-checkbox outlined v-model="showAll" class="mx-2" label="Alle anzeigen" @change="onChangeAll"></v-checkbox>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="12" xs="12" sm="4" class="pt-0 py-0" align="right">
      <v-text-field
          v-model="search"
          append-icon="search"
          label="Suche"
          single-line
          clearable
          hide-details
      ></v-text-field>
    </v-col>
    <v-col cols="12" xs="12" class="">
      <v-data-table
          :headers="headers"
          :items="deviceList"
          :search="search"
          fixed-header
          :height="tableHeight"
          hide-default-footer
          hide-details
          :show-expand="showExpand"
          :items-per-page="-1"

      >
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" v-html="getItemsAsLines(item)" style="text-align:left;" class="pa-4"></td>
        </template>
        <template v-slot:item.name="{ item }">
          <span class="handpointer" @click="editItem(item)"> {{item.name}}</span>
        </template>
        <template v-slot:item.items="{ item }">
          <span class="handpointer miniText" @click="editItem(item)">....</span>
          <span v-if="item.channel === 1"> (Kanal)</span>
          <span v-if="item.channel === 20"> (Kanal vom Veranstalter)</span>

        </template>

        <template v-slot:item.company="{ item }">
            <span v-if="item.companyName" @click="openCompanyDialog(item)">{{item.companyName}}
            </span>
          <span v-if="!item.companyName && !isChannels" class="handpointer" :style="getCompanyStyle(item)"
                @click="openCompanyDialog(item)">zuweisen</span>
        </template>
        <template v-slot:item.action="{ item }">

          <v-icon
              small
              class="mr-2"
              v-if="allowSharing"
              @click="shareItem(item)"
          >
            share
          </v-icon>
          <v-icon
              small
              class="mr-2"
              v-if="allowSharing || item.channel === 0"
              @click="editItem(item)"
          >
            edit
          </v-icon>
          <v-icon
              small
              v-if="item.channel === 0 || (allowSharing)"
              @click="deleteItem(item)"
          >
            delete
          </v-icon>
        </template>
      </v-data-table>
    </v-col>

    <DialogSharePlaylistsOnCompanies ref="dlgShare" @save="shareToCompanies"></DialogSharePlaylistsOnCompanies>
    <DialogShowShareStatistik ref="dlgShareStats"></DialogShowShareStatistik>
    <DialogLinkCompany ref="dlgLink" @save="onLinkCompany"></DialogLinkCompany>
    <DialogDeleteItem ref="dlgDelete" @doDelete="doDelete"></DialogDeleteItem>
    <DialogLinkChannelsGlobal ref="dlgShareGlobal" :removeVeranstalter='true' @save="onShareChannels" @remove="onRemoveChannels"></DialogLinkChannelsGlobal>
  </v-row>
</template>

<script>
import Vue from 'vue'
import DialogLinkCompany from './../module/dialogs/DialogLinkCompany'
import DialogDeleteItem from '../dialogs/DialogDeleteItem'
import DialogSharePlaylistsOnCompanies from './../module/dialogs/DialogSharePlaylistsOnCompanies'
import DialogShowShareStatistik from "../module/dialogs/DialogShowShareStatistik";
import DialogLinkChannelsGlobal from "@/components/module/dialogs/DialogLinkChannelsGlobal.vue";
var _ = require('lodash')
export default {
  name: 'TablePlayList',
  props: {
    companyId: String,
    showTitle: Boolean,
    allowSharing: Boolean,
    showExpand: Boolean,
    isCompanyView: Boolean,
    isChannels: Boolean
  },
  components: {
    DialogLinkChannelsGlobal,
    DialogShowShareStatistik, DialogLinkCompany, DialogDeleteItem, DialogSharePlaylistsOnCompanies},
  methods: {
    resize2: function () {
      this.tableHeight = window.innerHeight - 246;
      if (this.showTitle) {
        this.tableHeight = window.innerHeight - 246;
      }
      if (this.tableHeight < 150) {
        this.tableHeight = 150;
      }
    },
    resize: function () {
      if (!this.isCompanyView) {
        this.resize2();
        return;
      }
      this.tableHeight = window.innerHeight - 486;
      if (this.showTitle) {
        this.tableHeight = window.innerHeight - 386;
      }
      if (this.tableHeight < 150) {
        this.tableHeight = 150;
      }
    },
    deleteItem: function (item) {
      this.$refs.dlgDelete.open({
        type: 'Playlist',
        id: '' + item.guid,
        name: 'Playlist ' + item.name,
        item: item
      })
    },
    doDelete: function (item) {
      if (this.isCompanyView) {
        Vue.prototype.$api.unlinkPlayListFromCompany(item.item.guid,this.companyId, this.reload)
      } else {
        Vue.prototype.$api.deletePlaylist(item.item.guid, this.reload)
      }
    },
    openCompanyDialog: function (item) {
      console.log('openCompanyDialog', item)
      this.currentDevice = item
      this.$refs.dlgLink.open({
        title: 'Netzwerk zuweisen',
        description: 'Wählen Sie ein Netzwerk'
      })
    },
    onLinkCompany: function (item) {
      console.log('onLinkCompany', item)
      Vue.prototype.$api.linkPlayListToCompany(this.currentDevice, item, this.reload)
    },
    onChangeAll: function () {
      Vue.prototype.storage.saveState('playlistShowAll', this.showAll)
      this.reload()
    },
    shareChannels: function (item) {
      console.log('shareChannels', item)
      this.$refs.dlgShareGlobal.open({}, this.companyId)
    },
    onShareChannels: function (data) {
      console.log('onShareChannels', data)
      var xData = data
      _.forEach(xData.playlists, function (pl) {
        console.log('pl', pl.guid)
        _.forEach(xData.locations, function (loc) {
          console.log('loc', loc.guid)
          Vue.prototype.$api.createCloneLinkPlayListToCompany(pl, loc, function (data) {
            console.log('link done', data)
          })
        })
      })
    },
    onRemoveChannels: function (data) {
      console.log('onRemoveChannels', data)
      var xData = data
      _.forEach(xData.playlists, function (pl) {
        _.forEach(xData.locations, function (loc) {
          Vue.prototype.$api.removeCloneLinkPlayListToCompany(pl.guid, loc.guid, function (data) {
            console.log('unlink done', data)
          })
        })
      })
    },
    shareToCompanies: function (list) {
      console.log('shareToCompanies', list, this.itemToShare)
      if (list && this.itemToShare) {
        let companies = []
        _.forEach(list, function (company) {
          companies.push(company.guid)
        })
        console.log('companies', companies)
        Vue.prototype.$api.sharePlayListToCompanies(this.companyId, this.itemToShare.guid, companies, this.onShareDone)
      }
      this.itemToShare = null
    },
    onShareDone: function (result) {
      console.log('onShareDone', result)

      this.$refs['dlgShareStats'].open({title: 'Statistik', description: '', data: result})
    },
    shareItem: function (item) {
      if (this.isChannels) {
        this.shareChannels(item)
      } else {
        console.log('share Item', item)
        let cmp = this
        this.itemToShare = item
        this.$refs.dlgShare.open({
          itemToShare: cmp.itemToShare
        })
      }
    },
    editItem: function (item) {
      if (this.companyId) {
        this.$router.push('/Netzwerke/' + this.companyId + '/Playlist/' + item.guid)
      } else {
        this.$router.push('/Playlist/' + item.guid)
      }
    },
    getCompanyStyle: function (item) {
      var style = ''
      if (!item.company) {
        style = 'color: #aa4444;'
      }
      return style
    },
    toMB: function (bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      var k = 1024,
      dm = decimals <= 0 ? 0 : decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    reload: function () {
      console.log('playlist load', this.companyId)
      if (this.companyId) {
        Vue.prototype.$api.loadPlayListsFromCompany(this.companyId, this.onGetData)
      } else {
        if (this.isChannels) {
          Vue.prototype.$api.loadChannels(this.onGetData)
        } else {
          Vue.prototype.$api.loadPlayLists(this.onGetData)
        }

      }
    },
    getItemsAsLines: function (item) {
      if (!item) return ''
      if (!item.items) return ''
      var html = ''
      var arr = JSON.parse(item.items)
      for (var index in arr) {
        var row = arr[index]
        html += '<li>' + row
      }
      return html
    },
    onGetData: function (result) {
      console.log('result', result)
      if (this.showAll) {
        this.deviceList = result
      } else {
        var res = []
        for (var i in result) {
          var item = result[i]
          if (!item.companyName) {
            res.push(item)
          }
        }
        this.deviceList = res
      }
    }
  },
  data () {
    return {
      tableHeight: 200,
      itemToShare: null,
      currentDevice: null,
      search: null,
      showAll: false,
      headers: [
        {text: 'Name', align: 'left', value: 'name'},
        /*{text: 'Erstellt', value: 'created'},*/
        /*{text: 'Remote', value: 'remoteAddress'},*/
        {text: 'Netzwerk', value: 'company'},
        {text: 'Kommentar', value: 'comment'},
        {text: 'Aktion', value: 'action'}
      ],
      deviceList: []
    }
  },
  mounted () {
    if (this.isCompanyView) {
      this.showAll = true
      this.headers = [
        {text: 'Name', align: 'left', value: 'name'},
        {text: 'Items', value: 'items', width:'220'},
        {text: 'Kommentar', value: 'comment'},
        {text: 'Aktion', value: 'action'}
      ]
    } else {
      this.showAll = Vue.prototype.storage.getState('playlistShowAll')
    }
    var cmp = this
    this.$nextTick(() => {
      cmp.reload()
    })
    this.resize()
  },
  created() {
    Vue.prototype.$eventHub.$on('resize', this.resize)

  },
  destroyed() {
    Vue.prototype.$eventHub.$off('resize', this.resize)
  }
}
</script>

<style scoped>

</style>
